import { useAuth } from "@/hooks/use-auth";
import { hasUserProduct, type UserProductCode } from "@/lib/user-products";

export function useHasUserProduct(code: UserProductCode): boolean {
  const { user } = useAuth();
  return hasUserProduct(user?.products, code);
}
